/**
 * Event card — a single entry in the Viewing Deck event stream.
 *
 * CSS: styles/components/event-card.css
 */

import { esc } from '../../shared/rendering.js'
import type { EventCardProps } from '../../types/components.js'

/** Render an event card for the Viewing Deck. */
export function renderEventCard(props: EventCardProps): string {
  const iterLabel = props.iteration !== null ? `Iter ${props.iteration}` : ''
  const detailLabel = props.detailLabel ?? 'Details'
  const meta = [
    props.stage ? `<span class="ev-stage ${esc(props.stageClass)}">${esc(props.stage)}</span>` : '',
    iterLabel ? `<span class="ev-iter">${esc(iterLabel)}</span>` : '',
    props.repeatCount && props.repeatCount > 1
      ? `<span class="ev-repeat">×${props.repeatCount}</span>`
      : '',
    props.duration ? `<span class="ev-dur">${esc(props.duration)}</span>` : '',
  ]
    .filter(Boolean)
    .join('')

  return `<article class="ev">
    <div class="ev-gutter"><span class="ev-icon ${esc(props.iconClass)}">${esc(props.icon)}</span></div>
    <div class="ev-main">
      <div class="ev-h">
        <span class="ev-title">${esc(props.title)}</span>
        <span class="ev-time">${esc(props.timestamp)}</span>
      </div>
      ${meta ? `<div class="ev-meta">${meta}</div>` : ''}
      <div class="ev-body">${props.content}</div>
      ${props.detailHtml ? `<details class="ev-detail"><summary>${esc(detailLabel)}</summary>${props.detailHtml}</details>` : ''}
    </div>
  </article>`
}
